import { Icon } from '@iconify/react'
import { extractValue } from '../../utils/dashboardHelpers'

const QuickOverview = ({ overviewData, complianceStats, isLoading }) => {
  return (
    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
      {/* Header */}
      <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
        <div className="flex items-center gap-2">
          <Icon icon="mdi:speedometer" className="text-gray-600 text-xl" />
          <h2 className="text-lg font-semibold text-gray-800">Quick Overview</h2>
        </div>
      </div>

      {/* Content */}
      <div className="p-4">
        {isLoading ? (
          <div className="space-y-4">
            <div className="h-4 bg-gray-200 rounded animate-pulse w-3/4"></div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              {[1, 2, 3].map((i) => (
                <div key={i} className="text-center p-4 bg-gray-50 rounded-lg animate-pulse">
                  <div className="h-8 bg-gray-200 rounded mb-2 w-16 mx-auto"></div>
                  <div className="h-3 bg-gray-200 rounded w-20 mx-auto"></div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <>
            <p className="text-sm text-gray-500 mb-4">
              {overviewData?.summary ||
                `Your platform is monitoring ${extractValue(overviewData?.activeWebsites, 'count', 0)} websites with an average compliance score of ${extractValue(overviewData?.avgComplianceScore, 'score', 0)}%. The AI has automatically fixed ${extractValue(overviewData?.autoFixedIssues, 'count', 0).toLocaleString()} accessibility issues this month.`}
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              {complianceStats?.levelA || complianceStats?.levelAA || complianceStats?.levelAAA ? (
                <>
                  <div className="text-center p-4 bg-gray-50 rounded-lg border border-gray-100">
                    <div className="text-2xl font-bold text-gray-800 mb-1">
                      {complianceStats?.levelA?.percentage || 0}%
                    </div>
                    <div className="text-xs font-medium text-gray-600">WCAG Level A</div>
                    <div className="text-xs text-gray-400 mt-1">
                      {complianceStats?.levelA?.totalScans || 0} scans
                    </div>
                  </div>
                  <div className="text-center p-4 bg-gray-50 rounded-lg border border-gray-100">
                    <div className="text-2xl font-bold text-gray-800 mb-1">
                      {complianceStats?.levelAA?.percentage || 0}%
                    </div>
                    <div className="text-xs font-medium text-gray-600">WCAG Level AA</div>
                    <div className="text-xs text-gray-400 mt-1">
                      {complianceStats?.levelAA?.totalScans || 0} scans
                    </div>
                  </div>
                  <div className="text-center p-4 bg-gray-50 rounded-lg border border-gray-100">
                    <div className="text-2xl font-bold text-gray-800 mb-1">
                      {complianceStats?.levelAAA?.percentage || 0}%
                    </div>
                    <div className="text-xs font-medium text-gray-600">WCAG Level AAA</div>
                    <div className="text-xs text-gray-400 mt-1">
                      {complianceStats?.levelAAA?.totalScans || 0} scans
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="text-center p-4 bg-gray-50 rounded-lg border border-gray-100">
                    <div className="text-2xl font-bold text-gray-800 mb-1">0%</div>
                    <div className="text-xs font-medium text-gray-600">WCAG Level A</div>
                  </div>
                  <div className="text-center p-4 bg-gray-50 rounded-lg border border-gray-100">
                    <div className="text-2xl font-bold text-gray-800 mb-1">0%</div>
                    <div className="text-xs font-medium text-gray-600">WCAG Level AA</div>
                  </div>
                  <div className="text-center p-4 bg-gray-50 rounded-lg border border-gray-100">
                    <div className="text-2xl font-bold text-gray-800 mb-1">0%</div>
                    <div className="text-xs font-medium text-gray-600">WCAG Level AAA</div>
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default QuickOverview
